"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuoteRow = exports.QuoteRowDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_value_1 = require("./entity-value");
var content_node_1 = require("./content-node");
var coalesce_1 = require("../../utils/coalesce");
exports.QuoteRowDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: ", ";\n    flex-grow: 1;\n  "], ["\n    margin-top: ", ";\n    flex-grow: 1;\n  "])), theme_1.theme.UNIT(2))
});
var QuoteStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: relative;\n    padding-left: 62px;\n  "], ["\n    position: relative;\n    padding-left: 62px;\n  "])))
});
var SurroundStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: absolute;\n    font-size: ", ";\n    flex-shrink: 0;\n    color: ", " !important;\n  "], ["\n    position: absolute;\n    font-size: ", ";\n    flex-shrink: 0;\n    color: ", " !important;\n  "])), theme_1.theme.FONT_SIZE(86), theme_1.theme.COLOR('line-subtle'))
});
var OpenStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n    top: -16px;\n    left: 2px;\n  "], ["\n    ", ";\n    top: -16px;\n    left: 2px;\n  "])), SurroundStyles)
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Quote: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), QuoteStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  Content: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Open: styled_components_1.default.span(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), OpenStyles)
};
var QuoteRow = function (props) {
  var className = props.className,
    entity = props.entity;
  var person = entity.person;
  var description = (0, coalesce_1.coalesce)(entity, ['description', 'openGraph.description']);
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Value, {
    entity: person,
    label: "{{QUOTE}}"
  }), react_1.default.createElement(My.Quote, null, react_1.default.createElement(My.Open, null, "\u201C"), react_1.default.createElement(My.Content, {
    entity: description
  })));
};
exports.QuoteRow = QuoteRow;
exports.QuoteRow.defaultProps = exports.QuoteRowDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;